module.exports = __webpack_public_path__ + "static/media/254953HD_v2_Abilify_AssignedEd.6e4cb9e8.mp4";